import Resource from './Resource';

/** Suggests an email for a contact from the pattern the given company's contacts already use. */
class EmailSuggest extends Resource {
	constructor() {
		super('function/email-suggest');
	}

	suggest(clientId: number, firstName: string, lastName: string): Promise<string | null> {
		return this._getRequest(String(clientId), {
			methodName: 'suggest',
			params: { firstname: firstName, lastname: lastName }
		}).then((res: { data: { data?: string | null } }) => res.data.data ?? null);
	}
}

const resource = new EmailSuggest();

export default resource;
